
import { IonContent, IonSlides, IonSlide } from '@modus/ionic-vue'
import { defineComponent, ref } from 'vue'
import { RouterLink } from 'vue-router'
import useCategories from '@/composables/categories'

export default defineComponent({
  name: 'CategoryList',
  components: {
    RouterLink,
    IonContent,
    IonSlides,
    IonSlide,
  },
  async setup() {
    const { categories } = await useCategories()
    const isDesktop = ref(false)
    const slideOpts = ref({})

    const mql = window.matchMedia('(min-width: 800px)')

    function onWidthChange(query: MediaQueryList) {
      isDesktop.value = query.matches

      if (query.matches) {
        // desktop options
        slideOpts.value = {
          slidesPerView: 3,
          spaceBetween: 10,
          loop: true,
          grabCursor: true,
          autoplay: {
            delay: 5500,
            disableOnInteraction: true,
          },
        }
      } else {
        slideOpts.value = {
          // mobile options
          slidesPerView: 'auto',
          spaceBetween: 10,
          loop: true,
          autoplay: {
            delay: 3500,
            disableOnInteraction: true,
          },
        }
      }
    }

    mql.addListener(onWidthChange)
    onWidthChange(mql)

    return { categories, slideOpts }
  },
})
